module.exports = __webpack_public_path__ + "static/media/error404Bottom.086617d9.svg";